import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Badge, Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { Formik, Field, Form, useFormikContext } from 'formik';
import Loader from 'shared/common/loader';
import { toast } from 'react-toastify';
import UserHttp from '../services/profile.service';
import DashboardHttp from 'pages/profile/services/profile.service';
import { userStore } from '../../../store/UserStore';
import Toast from '../../../shared/common/toast';
import * as Yup from 'yup';
import infoIco from 'assets/images/i-circle.svg';
import successIco from 'assets/images/check.png';
import DocumentUpload from './document-upload';
import PanCardUpload from './pan-card-upload';
import CustomerPan from './customerPan';
import CustomerAadhaar from './customerAadhaar';
import BankModal from 'shared/bankEditModal/BankModal';

interface PropsType {
  user: any;
  customer: any;
}

const BankDetails: React.FC<PropsType> = ({ user, customer }) => {
  const [loading, setLoading] = useState<any>(true);
  const [bankDetails, setBankDetails] = useState<any>();
  const [upiDetails, setUpiDetails] = useState<any>();
  const [setCustomer] = userStore((state: any) => [state.setCustomer]);
  const [isBankSearch, setBankSearch] = useState(true);
  const [isBankSearching, setBankSearching] = useState(false);
  const ref = useRef(null);
  const refUpi = useRef(null);
  const [isIfscError, setIfscError] = useState(false);
  const [isUpiError, setUpiError] = useState(false);
  const [accountNumber, setAccountNumber] = useState<any>('');
  const [upiHandler, setUpiHandler] = useState<any>('');

  const [isAccountVerify, setAccountVerify] = useState(true);
  const [isAccountVerifing, setAccountVerifing] = useState(false);
  const [isAccountVerifySuccess, setAccountVerifySuccess] = useState(false);
  const [isAccountVerifyFeild, setAccountVerifyFeild] = useState(false);

  const [isUpiVerify, setUpiVerify] = useState(true);
  const [isUpiVerifing, setUpiVerifing] = useState(false);
  const [isUpiVerifySuccess, setUpiVerifySuccess] = useState(false);
  const [isUpiVerifyFeild, setUpiVerifyFeild] = useState(false);

  const [isBankLoading, setBankLoading] = React.useState(false);
  const [isBankEdit, setIsBankEdit] = useState<boolean>(false);
  const [isUpiEdit, setIsUpiEdit] = useState<boolean>(false);
  const [isUpiLoading, setUpiLoading] = React.useState(false);

  const [pennyRes, setPennyRes] = useState<any>();
  const [upiRes, setUpiRes] = useState<any>();

  const [isPanVerify, setPanVerify] = useState(true);
  const [isPanVerifing, setPanVerifing] = useState(false);
  const [isPanVerifySuccess, setPanVerifySuccess] = useState(false);
  const [isPanVerifyFeild, setPanVerifyFeild] = useState(false);
  const [panNumber, setPanNumber] = useState<any>('');
  const [isDocShow, setDocShow] = useState(false);
  const [isShowUpload, setIsShowUpload] = useState(false);

  //new
  const [isBankModal, setIsBankModal] = useState(false);

  const [isVerifyDisabled, setIsVerifyDisabled] = useState(false);
  const [newBankDetails, setNewBankDetails] = useState({
    bankAccount: customer?.bankDetails?.accountNo,
    nameAsOnBankAcount: customer?.bankDetails?.name,
    ifsc: customer?.bankDetails?.ifsc,
    bankName: customer?.bankDetails?.bank,
  });

  useEffect(() => {
    setBankDetails(customer.bankDetails);
    setUpiDetails(customer.upiDetails);
    setLoading(false);
    verify();
  }, []);

  useEffect(() => {
    verify();
    if (customer?.kyc?.pan?.value) {
      setPanNumber(customer.kyc.pan.value);
      verifyPanSuccess();
    }
  }, [customer]);

  const verify = () => {
    if (customer?.bankDetails) {
      setAccountNumber(customer.bankDetails.bankAccount);
      if (
        customer.bankDetails.state === 'VERIFIED' &&
        customer.bankDetails.accountNo
      ) {
        verifySuccess();
      } else {
        verifyFeild();
      }
    }

    if (customer?.upiDetails) {
      setUpiHandler(customer.upiDetails.upi);
      if (
        customer?.upiDetails?.state === 'VERIFIED' &&
        customer?.upiDetails?.accountNo
      ) {
        verifyUpiSuccess();
      } else {
        verifyUpiFeild();
      }
    }
  };
  const save = async (values: any, setErrors: any) => {
    setBankLoading(true);
    if (isIfscError) {
      let errors = {} as any;
      errors.ifsc = 'You have entered an invalid ifsc code.';
      setErrors(errors);
      return;
    }
    try {
      const res: any = await UserHttp.updateBankDetails({
        ...values,
        customerId: customer.customerId,
        bankAcVerification: pennyRes?.status,
      });
      if (res.status === 200 && res.data.data) {
        customer.bankDetails = res.data.data;
        setCustomer(customer);
        toast.success('Bank Details Updated Successfully');
      }
      setBankLoading(false);
    } catch (e: any) {
      setBankLoading(false);
      toast.error('Something went wrong');
    }
  };

  const saveUpiDetails = async (values: any, setErrors: any) => {
    upiDetails.customerId = customer.customerId;
    setUpiLoading(true);

    try {
      const res: any = await UserHttp.updateUpiDetails({
        ...values,
        customerId: customer.customerId,
        upiVerification: upiRes?.upiVerification,
      });
      if (res.status === 200 && res.data.data) {
        customer.upiDetails = res.data.data;
        setCustomer(customer);
        toast.success('UPI details updated successfully');
        // setLoading(false);
      }
      setUpiLoading(false);
    } catch (e: any) {
      setUpiLoading(false);

      // setLoading(false);
    }
  };

  const bankSearch = async (setFieldValue: any, setErrors: any) => {
    searchInprograss();
    try {
      const res: any = await UserHttp.searchBank(ref.current.values.ifsc);
      if (res.status === 200 && res.data) {
        setFieldValue('bankName', res.data.BANK, false);
        toSearch();
        setIfscError(false);
      } else {
        toSearch();
        setIfscError(true);
      }
    } catch (e: any) {
      let errors = {} as any;
      errors.ifsc = 'You have entered an invalid ifsc code.';
      setErrors(errors);
      toSearch();
      setIfscError(true);
    }
  };

  const toSearch = () => {
    setBankSearch(true);
    setBankSearching(false);
  };

  const searchInprograss = () => {
    setBankSearch(false);
    setBankSearching(true);
  };

  const toPanVerify = () => {
    setPanVerify(true);
    setPanVerifing(false);
    setPanVerifySuccess(false);
    setPanVerifyFeild(false);
  };

  const verifyPanSuccess = () => {
    setPanVerify(false);
    setPanVerifing(false);
    setPanVerifySuccess(true);
    setPanVerifyFeild(false);
  };

  const toVerify = () => {
    setAccountVerify(true);
    setAccountVerifing(false);
    setAccountVerifySuccess(false);
    setAccountVerifyFeild(false);
  };

  const verifyInprograss = () => {
    setAccountVerify(false);
    setAccountVerifing(true);
    setAccountVerifySuccess(false);
    setAccountVerifyFeild(false);
  };

  const verifySuccess = () => {
    setAccountVerify(false);
    setAccountVerifing(false);
    setAccountVerifySuccess(true);
    setAccountVerifyFeild(false);
  };

  const verifyFeild = () => {
    setAccountVerify(false);
    setAccountVerifing(false);
    setAccountVerifySuccess(false);
    setAccountVerifyFeild(true);
  };

  const accountVerify = async (setFieldValue: any, setErrors: any) => {
    verifyInprograss();
    if (!ref.current.values.ifsc) {
      let errors = {} as any;
      errors.ifsc = 'You have entered an invalid ifsc code.';
      setErrors(errors);
      return;
    }
    /** change api */
    try {
      const res: any = await UserHttp.accountVerify({
          transactionType: 'VERIFICATION',
          transactionMethod: 'IMPS',
          referenceId: customer.customerId,
          referenceType: 'CUSTOMER',
          // amount: 0,
          // partnerId: customer.partner.id,
          customerAccount: {
            accountType: 'BANK',
            name: ref.current.values.nameAsOnBankAcount,
            accountNo: ref.current.values.bankAccount,
            bank: ref.current.values.bankName,
            ifsc: ref.current.values.ifsc,
          },
        },
        user?.userId
      );
      if (res.status === 200 && res.data) {
        setPennyRes(res.data.data);
        verifySuccess();
        setIsBankEdit(false);
        setIfscError(false);
        setIsVerifyDisabled(true);
        let data;
        for (let i = 0; i <= 3; i++) {
          data = await DashboardHttp.getProfile(customer.customerId,user?.userId);
        }
        //setFieldValue('bankName', res.data.BANK, false);
        setCustomer(data.data.data.customer);
        if (data.data.data.customer.bankDetails.state === 'REJECTED') {
          verifyFeild();
          toast.error('Bank Details updated failed');
        } else {
          setPennyRes(res.data.data);
          verifySuccess();
          toast.success('Bank Details Updated Successfully');
        }
      } else {
        verifyFeild();
        setIfscError(true);
      }
    } catch (e: any) {
      if (e.data.errors[0].title) toast.error(e.data.errors[0].title);
      verifyFeild();
    }
  };

  const toUpiVerify = () => {
    setUpiVerify(true);
    setUpiVerifing(false);
    setUpiVerifySuccess(false);
    setUpiVerifyFeild(false);
  };

  const verifyUpiInprograss = () => {
    setUpiVerify(false);
    setUpiVerifing(true);
    setUpiVerifySuccess(false);
    setUpiVerifyFeild(false);
  };

  const verifyUpiSuccess = () => {
    setUpiVerify(false);
    setUpiVerifing(false);
    setUpiVerifySuccess(true);
    setUpiVerifyFeild(false);
  };

  const verifyUpiFeild = () => {
    setUpiVerify(false);
    setUpiVerifing(false);
    setUpiVerifySuccess(false);
    setUpiVerifyFeild(true);
  };

  const upiVerify = async (setFieldValue: any, setErrors: any) => {
    if (!refUpi.current.values.nameAsOnUPI)
      return toast.error('Please enter a name!');
    verifyUpiInprograss();

    if (!refUpi.current.values.upi) {
      let errors = {} as any;
      errors.upi = 'You have entered an invalid upi handler.';
      setErrors(errors);
      verifyUpiFeild();
      return;
    }
    /** change api */
    try {
      const res: any = await UserHttp.upiVerify({
        transactionType: 'VERIFICATION',
        transactionMethod: 'UPI',
        referenceId: customer.customerId,
        referenceType: 'CUSTOMER',
        customerAccount: {
          accountType: 'BANK',
          name: customer.bankDetails.nameAsOnBankAcount,
          accountNo: customer.bankDetails.bankAccount,
          bank: customer.bankDetails.bankName,
          ifsc: customer.bankDetails.ifsc,
        },
        upiAccount: {
          name: refUpi.current.values.nameAsOnUPI,
          upi: refUpi.current.values.upi,
          accountType: 'UPI',
        },
      });
      if (res.status === 200 && res.data) {
        const data = await DashboardHttp.getProfile(customer.customerId,user?.userId);
        setCustomer(data.data.data.customer);
        if (data.data.data.customer.upiDetails.state === 'REJECTED') {
          let errors = {} as any;
          errors.upi = res.data.data.message;
          setErrors(errors);
          verifyUpiFeild();
          setUpiError(true);
          toast.error('Failed to updated UPI details');
        } else {
          setUpiRes(res.data.data);
          verifyUpiSuccess();
          setIsUpiEdit(false);
          setUpiError(false);
          toast.success('UPI details updated successfully');
        }
      } else {
        verifyUpiFeild();
        setUpiError(true);
      }
    } catch (e: any) {
      let errors = {} as any;
      errors.upi = 'You have entered an invalid upi handler.';
      setErrors(errors);
      verifyUpiFeild();
      setUpiError(true);
    }
  };

  //new bankmodal

  const showbankModal = async () => {
    setIsBankModal(true);
  };
  const closebankModal = async () => {
    setIsBankModal(false);
  };

  //end bankmodal
  const getDocs = async () => {
    setDocShow(true);
  };

  const onHandleDocSideModal = (value) => {
    setDocShow(value);
  };

  const onHandleUploadSideModal = (value) => {
    setIsShowUpload(value);
  };

  useEffect(() => {
    if (
      newBankDetails?.bankAccount == customer?.bankDetails?.accountNo &&
      newBankDetails?.ifsc == customer?.bankDetails?.ifsc
    ) {
      setIsVerifyDisabled(true);
    } else {
      setIsVerifyDisabled(false);
    }
  }, [newBankDetails]);

  return (
    <>
      {loading && <Loader />}
      <DocumentUpload
        handleModal={onHandleDocSideModal}
        isShow={isDocShow}
        customerId={customer.customerId}
      />
      <PanCardUpload
        handleModal={onHandleUploadSideModal}
        isShow={isShowUpload}
        customerId={customer.customerId}
      />
      <Card className='pb-3'>
        <Card.Body className='p-5 pb-0'>
          <Card.Title>KYC Details</Card.Title>
          <Row>
            <Col md={6} sm={12} className='px-2'>
              <CustomerPan />
            </Col>

            <Col md={6} sm={12}>
              {/* <CustomerPan /> */}
              {customer.customerCategory === 'REGISTERED' ? null : (
                <CustomerAadhaar />
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className='mt-5'>
        <Card.Body className='p-5 pb-0'>
          <div>
            <Card.Title>Bank Details</Card.Title>

            <Formik
              innerRef={ref}
              initialValues={{
                bankAccount: customer?.bankDetails?.accountNo || '',
                nameAsOnBankAcount: customer?.bankDetails?.name || '',
                ifsc: customer?.bankDetails?.ifsc || '',
                bankName: customer?.bankDetails?.bank || '',
              }}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                setSubmitting(false);
                // save(values, setErrors);
                accountVerify(values, setErrors);
                //signIn(values);
              }}
              validationSchema={Yup.object().shape({
                bankAccount: Yup.number()
                  .typeError('You must specify a number')
                  .required('Invalid Account'),
                nameAsOnBankAcount: Yup.string().required('Name is required'),
                ifsc: Yup.string().required('IFSC code is required'),
                bankName: Yup.string().required('Bank name is required'),
              })}
            >
              {({
                values,
                isSubmitting,
                errors,
                touched,
                setErrors,
                setFieldValue,
                isValid,
                dirty,
              }) => (
                <Form translate={undefined}>
                  <Row>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>
                       Name as per your bank account, e.g., RAJ SHARMA
                        </label>
                        <Field
                          type='text'
                          placeholder=''
                          name='nameAsOnBankAcount'
                          disabled={isAccountVerifySuccess && !isBankEdit}
                          className='form-control'
                          onChange={(e) => {
                            if (/[^A-Za-z ]/.test(e.target.value)) return;
                            setFieldValue(
                              'nameAsOnBankAcount',
                              e.target.value?.toUpperCase()
                            );
                            setNewBankDetails({
                              ...newBankDetails,
                              nameAsOnBankAcount: e.target.value,
                            });
                          }}
                        />
                        <div className='error'>
                          {errors.nameAsOnBankAcount &&
                            touched.nameAsOnBankAcount && (
                              <small id='my-helper-text'>
                                <>
                                  <img src={infoIco} alt='' />
                                  {errors.nameAsOnBankAcount}
                                </>
                              </small>
                            )}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>Account Number</label>
                        <div className='input-group mb-3'>
                          <Field
                            type='text'
                            placeholder=''
                            name='bankAccount'
                            className='form-control'
                            value={values.bankAccount}
                            disabled={isAccountVerifySuccess && !isBankEdit}
                            onChange={(e) => {
                              toVerify();
                              if (
                                /[^0-9]/.test(e.target.value) ||
                                e.target.value?.length > 18
                              )
                                return;
                              setFieldValue('bankAccount', e.target.value);
                              setNewBankDetails({
                                ...newBankDetails,
                                bankAccount: e.target.value,
                              });
                            }}
                          />
                          <div className='input-group-text'>
                            <button
                              className='btn'
                              type='button'
                              disabled={true}
                              id='button-addon2'
                            >
                              {isAccountVerify ? (
                                <img src={infoIco} alt='' />
                              ) : (
                                ''
                              )}
                              {isAccountVerifing ? (
                                <div
                                  className='spinner-grow text-success'
                                  style={{ width: '1rem', height: '1rem' }}
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                ''
                              )}
                              {isAccountVerifySuccess ? (
                                <img
                                  style={{ width: '20px' }}
                                  src={successIco}
                                  alt=''
                                />
                              ) : (
                                ''
                              )}
                              {isAccountVerifyFeild ? (
                                <img src={infoIco} alt='' />
                              ) : (
                                ''
                              )}
                            </button>
                          </div>
                        </div>
                        <div className='error'>
                          {errors.bankAccount && touched.bankAccount && (
                            <small id='my-helper-text'>
                              <>
                                <img src={infoIco} alt='' />
                                {errors.bankAccount}
                              </>
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>IFSC Code</label>
                        <div className='input-group mb-3'>
                          <Field
                            type='text'
                            placeholder=''
                            name='ifsc'
                            className='form-control'
                            onChange={(e) => {
                              if (
                                /[^a-zA-Z0-9]/.test(e.target.value) ||
                                e.target.value?.length > 11
                              )
                                return;
                              setFieldValue(
                                'ifsc',
                                e.target.value?.toUpperCase()
                              );
                              setNewBankDetails({
                                ...newBankDetails,
                                ifsc: e.target.value,
                              });
                            }}
                            disabled={isAccountVerifySuccess && !isBankEdit}
                          />
                          <div className='input-group-text'>
                            <button
                              className='btn'
                              type='button'
                              onClick={() =>
                                bankSearch(setFieldValue, setErrors)
                              }
                              disabled={isAccountVerifySuccess && !isBankEdit}
                              id='button-addon2'
                            >
                              {isBankSearch ? <div>Search</div> : ''}
                              {isBankSearching ? (
                                <div
                                  className='spinner-grow text-success'
                                  style={{ width: '1rem', height: '1rem' }}
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                ''
                              )}
                            </button>
                          </div>
                        </div>
                        <div className='error'>
                          {errors.ifsc && touched.ifsc && (
                            <small id='my-helper-text'>
                              <>
                                <img src={infoIco} alt='' />
                                {errors.ifsc}
                              </>
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>Bank Name</label>
                        <Field
                          type='text'
                          placeholder=''
                          name='bankName'
                          className='form-control'
                          // disabled={true}
                          disabled={isAccountVerifySuccess && !isBankEdit}
                        />
                        <div className='error'>
                          {errors.bankName && touched.bankName && (
                            <small id='my-helper-text'>
                              <>
                                <img src={infoIco} alt='' />
                                {errors.bankName}
                              </>
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className='row'>
                    <div className='mt-3 d-flex justify-content-end py-4'>
                      {isAccountVerifySuccess && !isBankEdit ? (
                        // <Button
                        //   variant='primary'
                        //   className='mw'
                        //   onClick={() => setIsBankEdit(true)}
                        //   type='button'
                        // >
                        //   Edit
                        // </Button>

                        <Button
                          variant='primary'
                          className='mw'
                          onClick={() => showbankModal()}
                          type='button'
                        >
                          Edit
                        </Button>
                      ) : (
                        <>
                          {isAccountVerifySuccess && isBankEdit ? (
                            <Button
                              variant='secondary'
                              className='mw mx-2'
                              onClick={() => setIsBankEdit(false)}
                              type='button'
                            >
                              Cancel
                            </Button>
                          ) : null}
                          <Button
                            disabled={
                              isBankLoading ||
                              isAccountVerifing ||
                              isVerifyDisabled
                            }
                            variant='primary'
                            className='mw'
                            type='submit'
                          >
                            {isBankLoading || isAccountVerifing ? (
                              <>
                                Verifying..{' '}
                                <Spinner animation='border' size='sm'></Spinner>
                              </>
                            ) : (
                              'Verify and Save'
                            )}
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card.Body>
      </Card>
      <Card className='mt-5'>
        <Card.Body className='p-5 pb-0'>
          <div>
            <Card.Title>UPI Details</Card.Title>
            <Formik
              innerRef={refUpi}
              initialValues={{
                nameAsOnUPI: customer?.upiDetails?.name || '',
                upi: customer?.upiDetails?.accountNo || '',
              }}
              onSubmit={(values, { setSubmitting, setErrors }) => {
                setSubmitting(false);
                // saveUpiDetails(values, setErrors);
                upiVerify(values, setErrors);
                //signIn(values);
              }}
              validationSchema={Yup.object().shape({
                nameAsOnUPI: Yup.string().required('Name is required'),
                upi: Yup.string().required('UPI handle is required'),
              })}
            >
              {({
                values,
                isSubmitting,
                errors,
                touched,
                setErrors,
                setFieldValue,
                isValid,
                dirty,
              }) => (
                <Form translate={undefined}>
                  <Row>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>Name As per UPI</label>
                        <Field
                          type='text'
                          placeholder=''
                          name='nameAsOnUPI'
                          className='form-control'
                          disabled={isUpiVerifySuccess && !isUpiEdit}
                        />
                        <div className='error'>
                          {errors.nameAsOnUPI && touched.nameAsOnUPI && (
                            <small id='my-helper-text' className='text-danger'>
                              <>
                                <img src={infoIco} alt='' />
                                {errors.nameAsOnUPI}
                              </>
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='form-group mb-2'>
                        <label className='form-label'>UPI Handle</label>
                        <div className='input-group mb-3'>
                          <Field
                            type='text'
                            placeholder=''
                            name='upi'
                            className='form-control'
                            value={values.upi}
                            disabled={isUpiVerifySuccess && !isUpiEdit}
                            onChange={(e) => {
                              toUpiVerify();
                              setFieldValue('upi', e.target.value);
                            }}
                          />
                          <div className='input-group-text'>
                            <button
                              className='btn'
                              type='button'
                              id='button-addon2'
                              disabled={true}
                            >
                              {isUpiVerify ? <img src={infoIco} alt='' /> : ''}
                              {isUpiVerifing ? (
                                <div
                                  className='spinner-grow text-success'
                                  style={{ width: '1rem', height: '1rem' }}
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                ''
                              )}
                              {isUpiVerifySuccess ? (
                                <img
                                  style={{ width: '20px' }}
                                  src={successIco}
                                  alt=''
                                />
                              ) : (
                                ''
                              )}
                              {isUpiVerifyFeild ? (
                                <img src={infoIco} alt='' />
                              ) : (
                                ''
                              )}
                            </button>
                          </div>
                        </div>
                        <div className='error'>
                          {errors.upi && touched.upi && (
                            <small id='my-helper-text' className='text-danger'>
                              <>
                                <img src={infoIco} alt='' />
                                {errors.upi}
                              </>
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className='row'>
                    <div className='mt-3 d-flex justify-content-end py-4'>
                      {isUpiVerifySuccess && !isUpiEdit ? (
                        <Button
                          variant='primary'
                          className='mw'
                          onClick={() => setIsUpiEdit(true)}
                          type='button'
                        >
                          Edit
                        </Button>
                      ) : (
                        // <></>
                        <>
                          {isUpiVerifySuccess && isUpiEdit ? (
                            <Button
                              variant='secondary'
                              className='mw mx-2'
                              onClick={() => setIsUpiEdit(false)}
                              type='button'
                            >
                              Cancel
                            </Button>
                          ) : null}
                          <Button
                            disabled={isUpiLoading || isUpiVerifing}
                            variant='primary'
                            className='mw'
                            type='submit'
                          >
                            {isUpiLoading || isUpiVerifing ? (
                              <>
                                Verifying..{' '}
                                <Spinner animation='border' size='sm'></Spinner>
                              </>
                            ) : (
                              'Verify and Save'
                            )}
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            {/* <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="upiName">
                  <Form.Label>Name As per UPI</Form.Label>
                  <Form.Control
                    type="text"
                    value={upiDetails?.nameAsOnUPI || ''}
                    onChange={(event) => setUpiDetails({
                      ...upiDetails,
                      nameAsOnUPI: event.target.value,
                    })}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="upiHandle">
                  <Form.Label>UPI Handle</Form.Label>
                  <Form.Control
                    type="text"
                    value={upiDetails?.upi || ''}
                    onChange={(event) => setUpiDetails({
                      ...upiDetails,
                      upi: event.target.value,
                    })}
                  />
                </Form.Group>
              </Col>
            </Row>*/}
          </div>
        </Card.Body>
        {/* <div className="mt-3 d-flex justify-content-end bg-light px-5 py-4">
          <Button variant="primary" className="mw" size="lg" onClick={saveUpiDetails}>
            Save
          </Button> 

        </div>*/}
      </Card>
      <BankModal show={isBankModal} onClick={closebankModal}/>
    </>
  );
};

export default BankDetails;
